import styled from '@emotion/styled'
import { wrapContained as withStyle } from 'utils/styles'

export default withStyle((props) => {
  const { theme } = props
  return `
    .ant-select-selection{
      padding-left:1.3em;
      text-transform: uppercase;
      input{
        text-transform: uppercase;
      }
      &::before{
        content: '0x';
        text-transform: lowercase; /* to override the value on the parent */
        position: absolute;
        left:11px;  /*replicate padding in the andt input.*/
        height: 100%;
        display: flex;
        align-items: center;
        color: ${theme.inputMaskingCharColor}
      }
    }
    .ant-select-dropdown-menu{
      text-transform: uppercase;
    }
    .chec-select-menu{
      width:102px;
      font-size: 12px;
    }
  `
})

export const AddButtonStyles = styled.div(({ canMakeNewId, theme }) => {
  const canAdd = `
    cursor: pointer;
    color: ${theme.linkColor};
  `
  const cannotAdd = `
    color: ${theme.inputFontDisabledColor}
  `
  return `
    text-align:center;
    background-color:${theme.dropdownFooterColor};
    padding:5px;
    ${canMakeNewId ? canAdd : cannotAdd}
  `
})
